import * as React from 'react';
import { Button, Space } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import reactJsonView from 'react-json-view';
import { TestCaseTurn, AgentInfo } from '@interface/index';
import { getUserInfo, getAgentInfo, isEqual } from '@lib/index';
import { createAgentPayload } from '@page/intent/common-apis';
import { Message, Action, MessageType } from '@opencui/copilot-react';
const chatBotIcon = require('@static/image/copilot/copilot-bot.png');
const ReactJson = reactJsonView;
import './index.less';

function copilotSession({ messages, excuteCardAction }: {
  messages: Message[];
  excuteCardAction: (card: Action) => void;
}) {

  const agent: AgentInfo | undefined = getAgentInfo();

  return <div
    id="copilot-session-wrap"
    className="session-wrap"
  >
    {messages.map((msg: Message, index: number) => {


      if (msg.user.name === 'Builder') {

        const query = msg.text;

        return <div key={`turn-wrap-${index}`} style={{ width: '100%', marginTop: 12 }}>
          {
            query &&
            <div key="user-query" className="user-query">
              <span>
                <pre className="session-text-wrap">
                  {query}
                </pre>
              </span>

              <span style={{ marginLeft: 16 }}>
                <img width="24px" src={getUserInfo().headimgurl} />
              </span>
            </div>
          }
        </div>;
      }

      const reply = msg.text;
      const title = msg.messageType === MessageType.Card && msg.title;
      const media = msg.messageType === MessageType.Card && msg.richMedia;

      return <div key={`turn-wrap-${index}`} style={{ width: '100%', marginTop: 12 }}>
        <div
          key="bot-reply"
          className="chat-bot-reply"
        >
          <img className="icon-img" key="bot-img" src={agent && agent.iconUrl || chatBotIcon} />
          <span key="bot-content" className={`reply-content-wrap ${msg.messageType === MessageType.Card ? 'session-text-wrap' : ''}`}>

            {reply.length > 0 &&
              <div className="bot-message "
              // style={{ display: 'flex', flexDirection: 'column' }}
              >
                <span style={{ display: 'inline-block' }}>
                  {title && <h3>{title}</h3>}
                  <pre className={`${msg.messageType !== MessageType.Card ? 'session-text-wrap' : ''}`} >
                    {
                      reply
                    }
                  </pre>
                  {media && <img style={{ maxWidth: '100%' }} src={media.fileURL} alt={media.altText} />}
                </span>

              </div>
            }
            {msg.actionList && msg.actionList.length && <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: -4, marginRight: -4 }}>
              {
                msg.actionList.map((card: Action) => {
                  return <Button onClick={() => {
                    excuteCardAction(card);
                  }} type="primary" style={{ margin: 4 }}>{card.text}</Button>;
                })
              }
            </div> || ''
            }
          </span>
        </div>
      </div>;
    })}
  </div >;
}

function parseReply(reply: any) {
  const re: any = JSON.parse(reply);

  let tmp = '';

  (re || []).forEach((obj: any) => {
    if (typeof obj === 'string') {
      if (tmp.length > 0) {
        tmp = tmp + '\n';
      }

      tmp = tmp + obj;
    } else if (obj.type === 'text') {
      const text = obj.payload && obj.payload.text || obj.text;

      if (text && text.length > 0) {
        if (tmp.length > 0) {
          tmp = tmp + '\n';
        }

        tmp = tmp + text;
      }
    }
  });

  return tmp;
}

export const CopilotSession = copilotSession;
